import { render, staticRenderFns } from "./NewIssueForm.vue?vue&type=template&id=6c7432c7&scoped=true&"
import script from "./NewIssueForm.vue?vue&type=script&lang=js&"
export * from "./NewIssueForm.vue?vue&type=script&lang=js&"
import style0 from "./NewIssueForm.vue?vue&type=style&index=0&id=6c7432c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7432c7",
  null
  
)

export default component.exports